var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRealtime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 20.2493H4.46875C4.27813 20.2493 4.09531 20.1735 3.96052 20.0388C3.82573 19.904 3.75 19.7211 3.75 19.5305V11.6242C3.75 10.4916 3.97309 9.37004 4.40654 8.32361C4.83998 7.27718 5.4753 6.32637 6.2762 5.52547C7.0771 4.72456 8.02791 4.08925 9.07435 3.6558C10.1208 3.22236 11.2423 2.99927 12.375 2.99927H12.375C13.5077 2.99927 14.6292 3.22236 15.6756 3.65581C16.7221 4.08925 17.6729 4.72457 18.4738 5.52547C19.2747 6.32638 19.91 7.27719 20.3435 8.32362C20.7769 9.37006 21 10.4916 21 11.6243V11.6243C21 13.9118 20.0913 16.1056 18.4738 17.7231C16.8563 19.3406 14.6625 20.2493 12.375 20.2493Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 10.4993H15",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 13.4993H15",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealtime);
export default __webpack_public_path__ + "static/media/Realtime.82c735cfe64e5e850a78c05d774e440b.svg";
export { ForwardRef as ReactComponent };